module.exports = __webpack_public_path__ + "img/centrealphachoisy.0912d1d7.png";